<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Billings</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Billings</li>
        </ol>
      </nav>
    </div>
    <!-- <div class="head-icons ms-2">
      <a
        href="javascript:void(0);"
        class=""
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        data-bs-original-title="Collapse"
        id="collapse-header"
      >
        <i class="ti ti-chevrons-up"></i>
      </a>
    </div> -->
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="mb-2" *ngIf="getCurrentSubscription() as subscription">
        <!-- Autopay is already active -->
        <ng-container *ngIf="subscription.autopayOptedIn; else autopayInactive">
          <div
            class="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2"
          >
            <a
              href="javascript:void(0)"
              class="btn btn-primary d-flex align-items-center"
              (click)="changeAutopayMethod()"
            >
              <i class="ti ti-credit-card me-2"></i>
              Change Autopay Method
            </a>

            <a
              href="javascript:void(0)"
              class="btn btn-outline-danger d-flex align-items-center"
              (click)="disableAutopay()"
            >
              <i class="ti ti-player-pause me-2"></i>
              Deactivate Autopay
            </a>
          </div>
        </ng-container>

        <!-- Autopay is NOT active -->
        <ng-template #autopayInactive>
          <a
            href="javascript:void(0)"
            class="btn btn-success d-flex align-items-center"
            (click)="activateAutopay()"
          >
            <i class="ti ti-player-play me-2"></i>
            Activate Autopay
          </a>
        </ng-template>
      </div>

      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="row">
    <div class="card">
      <div
        class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
      >
        <!-- <h5>Admin Attendance</h5> -->
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
          <div class="me-3">
            <select
              data-extension-safe
              class="form-select form-select-sm col-md-1"
              id="entries"
              [(ngModel)]="pageLimit"
              (change)="onPageLimitChange()"
            >
              <!-- <option selected disabled>Show Entries Per Page</option> -->
              <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
            </select>
          </div>
          <!-- <div class="me-3">
            <select
              class="form-select"
              [value]="filter"
              (change)="onFilterChange($any($event.target).value)"
            >
              <option value="">All</option>
              <option value="active">Active</option>
              <option value="cancelled">Cancelled</option>
              <option value="expired">Expired</option>
            </select>
          </div> 

          <div class="form-sort search-box">
            <label>
              <input
                type="text"
                class="form-control"
                placeholder="Search..."
                (input)="onSearch($any($event.target).value)"
            /></label>
          </div>-->
          <!-- <div class="form-sort">
                                  <label> <input type="search" [(ngModel)]="search" (input)="getTodayAttendance()" class="form-control"
                                      placeholder="Search"></label>
                        
                                </div> -->
        </div>
      </div>

      <div class="card-body p-0 mt-0">
        <div class="custom-datatable-filter table-responsive">
          <app-loader *ngIf="isLoading"></app-loader>
          <ng-container *ngIf="!isLoading">
            <ng-container *ngIf="billing$ | async as billingData">
              <table class="table datatable" *ngIf="billingData.data.length > 0; else noRecords">
                <thead class="thead-light">
                  <tr>
                    <th>Purchased On</th>
                    <th>Total Licences</th>
                    <th>Used Licences</th>
                    <!-- <th>Charge</th> -->
                    <th>Amount</th>
                    <th>Payment Method</th>
                    <th>Autopay Payment Method</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let licence of billingData.data">
                    <td>
                      {{ licence.createdAt | date: 'mediumDate' }}
                    </td>

                    <td>
                      {{ licence.totalLicences }}
                    </td>

                    <td>
                      {{ licence.usedLicences }}
                    </td>

                    <td>
                      {{
                        licence.chargeAmount
                          | currency: licence.subscription.planCurrencySymbol : 'symbol' : '1.2-2'
                      }}
                    </td>

                    <!-- <td>
                      {{
                        licence.amount
                          | currency: licence.subscription.planCurrencySymbol : 'symbol' : '1.2-2'
                      }}
                    </td> -->

                    <td>
                      <ng-container
                        *ngIf="getPaymentResponse(licence.payments?.[0]) as payment; else noMethod"
                      >
                        <span class="d-flex align-items-center">
                          <i class="ti me-1" [ngClass]="getPaymentMethodIcon(payment.method)"></i>

                          <div>
                            <div>
                              {{ formatPaymentMethod(payment) }}
                            </div>

                            <small class="text-muted" *ngIf="payment.method === 'card'">
                              {{ getPaymentCardDetails(payment) }}
                            </small>
                          </div>
                        </span>
                      </ng-container>

                      <ng-template #noMethod>
                        <span class="text-muted">—</span>
                      </ng-template>
                    </td>

                    <td>
                      <ng-container
                        *ngIf="licence.subscription as subscription; else noAutopayMethod"
                      >
                        <div class="d-flex align-items-center">
                          <!-- <i
                            class="ti me-2"
                            [ngClass]="getPaymentMethodIcon(subscription.autopayMethod)"
                          ></i> -->

                          <div>
                            <!-- Payment Method -->
                            <div class="fw-medium">
                              {{ formatPaymentMethodForAutopay(subscription.autopayMethod) }}
                            </div>

                            <!-- Card -->
                            <ng-container *ngIf="subscription.autopayMethod === 'card'">
                              <small class="text-muted">
                                {{ subscription.autopayCardNetwork || 'Card' }}
                                ****{{ subscription.autopayCardLast4 || '----' }}

                                <ng-container *ngIf="subscription.autopayCardType">
                                  · {{ subscription.autopayCardType }}
                                </ng-container>
                              </small>

                              <br />

                              <small class="text-muted" *ngIf="subscription.autopayCardIssuer">
                                {{ subscription.autopayCardIssuer }}
                              </small>
                            </ng-container>

                            <!-- UPI -->
                            <ng-container *ngIf="subscription.autopayMethod === 'upi'">
                              <small class="text-muted">
                                {{ subscription.autopayUpiVpa || 'UPI VPA not available' }}
                              </small>
                            </ng-container>

                            <!-- Net Banking -->
                            <ng-container *ngIf="subscription.autopayMethod === 'netbanking'">
                              <small class="text-muted">
                                {{ subscription.autopayBankName || 'Bank details not available' }}
                              </small>
                            </ng-container>

                            <!-- Wallet -->
                            <ng-container *ngIf="subscription.autopayMethod === 'wallet'">
                              <small class="text-muted"> Wallet </small>
                            </ng-container>

                            <!-- eMandate -->
                            <ng-container *ngIf="subscription.autopayMethod === 'emandate'">
                              <small class="text-muted"> e-Mandate </small>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>

                      <ng-template #noAutopayMethod>
                        <span class="text-muted">—</span>
                      </ng-template>
                    </td>

                    <td class="justify-content-center">
                      <div
                        class="action-icon d-inline-flex"
                        *ngIf="
                          licence.subscription.subscriptionStatus !== subscriptionStatus.Trialing
                        "
                      >
                        <a
                          href="javascript:void(0)"
                          class="me-2"
                          (click)="
                            openInvoiceModal(
                              SubscriptionInvoiceComponent,
                              licence,
                              licence.subscription.business,
                              billingData.adminBusiness,
                              licence.subscription
                            )
                          "
                        >
                          <i class="ti ti-file"></i>
                        </a>

                        <a
                          *ngIf="isAdmin()"
                          href="javascript:void(0)"
                          class="me-2"
                          (click)="
                            openEditBusinessModal(
                              licence.subscription.business,
                              SubscriptionInvoiceComponent,
                              licence.payments?.[0]?.id ?? ''
                            )
                          "
                        >
                          <i class="ti ti-pencil"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <ng-template #noRecords>
                <div class="text-center">Record not available</div>
              </ng-template>

              <div
                class="d-flex align-items-center justify-content-between ms-2"
                *ngIf="billingData.data.length > 0"
              >
                <div>
                  <!-- Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ totalCount }} entries -->
                  Showing
                  {{ totalCount === 0 ? 0 : (currentPage - 1) * pageLimit + 1 }}
                  to
                  {{ totalCount === 0 ? 0 : pageLastRecord }}
                  of
                  {{ totalCount }}
                </div>
                <div class="has-text-centered mt-3">
                  <app-pagination
                    [currentPage]="currentPage"
                    [pageSize]="pageLimit"
                    [totalRows]="totalCount"
                    (pageChange)="onPageChange($event)"
                  ></app-pagination>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- pagination -->
      <!-- <ng-container *ngIf="!isLoading">
        <ng-container *ngIf="billing$ | async as employeeClockInOut"> -->

      <!-- </ng-container>
      </ng-container> -->
    </div>
  </div>
</div>

<!-- invoice edit modal -->
<ng-template #editBusinessModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Edit Business Details</h5>

    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <form [formGroup]="businessForm" (ngSubmit)="updateBusiness(modal)">
    <div class="modal-body">
      <div class="row">
        <!-- Business Name -->
        <div class="col-md-6 mb-3">
          <label class="form-label"> Business Name <span class="text-danger">*</span> </label>

          <input type="text" class="form-control" formControlName="businessName" />

          <small
            class="text-danger"
            *ngIf="
              businessForm.get('businessName')?.touched && businessForm.get('businessName')?.invalid
            "
          >
            Business name is required
          </small>
        </div>

        <!-- Legal Name -->
        <div class="col-md-6 mb-3">
          <label class="form-label"> Legal Name </label>

          <input type="text" class="form-control" formControlName="legalName" />
        </div>

        <!-- Address -->
        <div class="col-md-12 mb-3">
          <label class="form-label"> Address </label>

          <textarea rows="3" class="form-control" formControlName="address"></textarea>
        </div>

        <!-- City -->
        <!-- <div class="col-md-4 mb-3">
          <label class="form-label"> City </label>

          <input type="text" class="form-control" formControlName="city" />
        </div> -->

        <!-- State -->
        <!-- <div class="col-md-4 mb-3">
          <label class="form-label"> State </label>

          <input type="text" class="form-control" formControlName="state" />
        </div> -->

        <!-- Country -->
        <!-- <div class="col-md-4 mb-3">
          <label class="form-label"> Country </label>

          <input type="text" class="form-control" formControlName="country" />
        </div> -->

        <!-- Zip -->
        <!-- <div class="col-md-4 mb-3">
          <label class="form-label"> ZIP Code </label>

          <input type="text" class="form-control" formControlName="zipCode" />
        </div> -->

        <!-- GST -->
        <div class="col-md-6 mb-3">
          <label class="form-label"> GST Number </label>

          <input type="text" class="form-control" formControlName="GST" />
        </div>

        <!-- PAN -->
        <div class="col-md-6 mb-3">
          <label class="form-label"> PAN </label>

          <input type="text" class="form-control" formControlName="PAN" />
        </div>

        <!-- Email -->
        <div class="col-md-6 mb-3">
          <label class="form-label"> Email </label>

          <input type="email" class="form-control" formControlName="email" />

          <small
            class="text-danger"
            *ngIf="businessForm.get('email')?.touched && businessForm.get('email')?.invalid"
          >
            Please enter a valid email
          </small>
        </div>

        <!-- Contact -->
        <div class="col-md-6 mb-3">
          <label class="form-label"> Contact Number </label>

          <input type="text" class="form-control" formControlName="mobile" />
        </div>

        <!-- Website -->
        <!-- <div class="col-md-6 mb-3">
          <label class="form-label"> Website </label>

          <input type="text" class="form-control" formControlName="website" />
        </div> -->
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light border me-2" (click)="modal.dismiss()">
        Cancel
      </button>

      <button type="submit" class="btn btn-primary" [disabled]="isUpdatingBusiness">
        <span *ngIf="isUpdatingBusiness" class="spinner-border spinner-border-sm me-1"></span>

        {{ isUpdatingBusiness ? 'Updating...' : 'Update Business' }}
      </button>
    </div>
  </form>
</ng-template>
<!-- invoice edit modal end -->
